module.exports = __webpack_public_path__ + "media/application/images/landing_header/underlay_01-8fe98273a5ee895c1616a9017ad8a13d.png";